/**
 * kind 等で網羅的に処理すべき箇所にといて、未処理のケースが残っていたらコンパイルエラーにするためのユーティリティ関数
 * @param x
 */
export function assertNever(x: never): never {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  throw new Error(`Unexpected value: ${x}`)
}
